module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _vm._v("The order of Assassins was founded in Persia at the end of the 11th Century. They were committed to anyone willing to pay for the service. Assassins were skeptical of the existence of God and believed that the world of the mind came into existence first, then, finally, the rest of creation.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("Standard Dictionary of Folklore,"), _c('br'), _vm._v("Mythology and Legend")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("I am you and you are me and what have we done to each other?")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("The Keener’s Manual")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8d23bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/epi.vue
// module id = 69
// module chunks = 0